import { useLanguage } from '../../context/LanguageContext';
import aboutImg from '../../assets/about-building.webp';
import './About.css';

export function About() {
    const { t, language } = useLanguage();
    const isRtl = language === 'ar';

    const points = isRtl ? [
        "شركة رائدة في مجال الإنشاءات والتصميم الداخلي",
        "فريق متخصص من المهندسين والمصممين المهرة",
        "سجل حافل بالمشاريع الناجحة لأكثر من 7 اعوام"
    ] : [
        t('about.check1'),
        t('about.check2'),
        t('about.check3')
    ];

    return (
        <section className="wow-about" dir={isRtl ? 'rtl' : 'ltr'}>
            <div className="wow-container">
                <div className="wow-flex-layout">
                    
                    <div className="wow-visual-column">
                        <div className="wow-image-wrapper">
                            <div className="wow-bg-accent"></div>
                            <img src={aboutImg} alt="Luxury Interior" className="wow-main-img" />
                            <div className="wow-experience-badge">
                                <div className="wow-badge-content">
                                    <div className="wow-stat">
                                        <span className="wow-num">07</span>
                                        <span className="wow-lab">{isRtl ? 'سنوات تميز' : 'Years Excellence'}</span>
                                    </div>
                                    <div className="wow-stat-line"></div>
                                    <div className="wow-stat">
                                        <span className="wow-num">2019</span>
                                        <span className="wow-lab">{isRtl ? 'تأسست في' : 'Since'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="wow-text-column">
                        <div className="wow-content-header">
                            <div className="wow-pre-title">
                                <span className="wow-dash-line"></span>
                                {t('about.label')}
                            </div>
                            <h2 className="wow-main-title">
                                {isRtl ? (
                                    <>نبني <span className="text-gold">رؤيتك</span> <br/> بواقع احترافي</>
                                ) : (
                                    <>Building Your <span className="text-gold">Vision</span> <br/> Into Reality</>
                                )}
                            </h2>
                        </div>

                        <div className="wow-body-box">
                            <p className="wow-lead-text">
                                {isRtl 
                                    ? "منذ انطلاقنا في عام 2019، وضعنا بصمة فريدة في عالم الإنشاءات والتصميم الداخلي." 
                                    : "Since our inception in 2019, we have carved a unique footprint in the world of construction and interior design."}
                            </p>
                        </div>

                        <div className="wow-features-grid">
                            {points.map((text, i) => (
                                <div key={i} className="wow-feature-card">
                                    <div className="wow-feature-icon">0{i + 1}</div>
                                    <div className="wow-feature-title">{text}</div>
                                    <div className="wow-hover-line"></div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}
